import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import type {
    GetCallActivity as GetCallActivityQuery,
    GetCallActivityVariables,
    GetCallActivity_activity as Activity,
} from 'nutshell-graphql-types';

import GET_CALL_ACTIVITY from '../queries/get-call-activity.graphql';

export const useGetCallActivity = (
    activityId?: string | null
): {
    activity: Activity | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
    startPolling: (arg1: number) => void;
    stopPolling: () => void;
} => {
    const {loading, data, error, refetch, startPolling, stopPolling} = useQuery<
        GetCallActivityQuery,
        GetCallActivityVariables
    >(GET_CALL_ACTIVITY, {
        variables: {
            // @ts-expect-error
            activityId,
        },
        skip: !activityId,
    });

    const activity = data ? data.activity : null;

    return {
        activity,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
        startPolling,
        stopPolling,
    };
};
